import React from "react";
import ChartCard from "./ChartCard";
import Pie from "../charts/Pie";

export default class ApplianceVersionDistributionCard extends React.Component{
    render(){
        return (
            <ChartCard title="Appliance version distribution">
                <Pie resource="version-distribution" />
            </ChartCard>
        )
    }
}